import { createContext, type ReactNode, useContext, useMemo, useState } from 'react';

type AuthModalMode = 'login' | 'register';

interface AuthModalContextValue {
  isOpen: boolean;
  mode: AuthModalMode;
  open: (mode?: AuthModalMode) => void;
  close: () => void;
  setMode: (mode: AuthModalMode) => void;
}

const AuthModalContext = createContext<AuthModalContextValue | null>(null);

export function AuthModalProvider({ children }: { children: ReactNode }) {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<AuthModalMode>('login');

  const value = useMemo<AuthModalContextValue>(
    () => ({
      isOpen,
      mode,
      open: (nextMode) => {
        if (nextMode) setMode(nextMode);
        setIsOpen(true);
      },
      close: () => setIsOpen(false),
      setMode,
    }),
    [isOpen, mode],
  );

  return <AuthModalContext.Provider value={value}>{children}</AuthModalContext.Provider>;
}

export function useAuthModal(): AuthModalContextValue {
  const context = useContext(AuthModalContext);
  if (!context) throw new Error('useAuthModal має використовуватись усередині AuthModalProvider');
  return context;
}
